import useStore from '../../../stores/helpers/use-context';
import type { RoutesPlannerTask } from '@bringg-frontend/routes-planner';

type SkillsValidatorResult = {
	success: boolean;
	missingSkills?: string[];
};
export const useSkillsValidator = () => {
	const { configuration, driversById, routesById, vehiclesById } = useStore();

	const areAllRequiredSkillsOnNewRoute = (tasks: RoutesPlannerTask[], newRouteId: number): SkillsValidatorResult => {
		const uniqueTasksSkills = new Set(tasks.flatMap(task => task.required_skills));
		const newRoute = routesById[newRouteId];
		const driverSkills = (newRoute.user_id && driversById[newRoute.user_id].skills) || [];
		const vehicleSkills = (newRoute.vehicle_id && vehiclesById[newRoute.vehicle_id].skills) || [];
		let skills;
		if (configuration.doSkillsIntersection) {
			skills = driverSkills.filter(skill => vehicleSkills.includes(skill));
		} else {
			skills = [...driverSkills, ...vehicleSkills];
		}
		const uniqueSkills = new Set(skills);

		const missingSkills = Array.from(uniqueTasksSkills).filter(skill => !uniqueSkills.has(skill));
		if (missingSkills.length === 0) {
			return { success: true };
		}

		return { success: false, missingSkills };
	};

	return { areAllRequiredSkillsOnNewRoute };
};
